import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from './Footer.module.css';

const year = new Date().getFullYear();
const Footer = () => (
  <div className={styles.footer}>
    <Row noGutters className={`${styles.footerRow} text-center`}>
      <Col xs={7} md={6} className='mx-auto'>
        <span>&copy; {year} Concentra Corporation. All Rights Reserved</span>
        <br />
        <br />
        <span>For assistance with Logging In or Registering, please contact the Concentra Solution Center at 877-327-2771</span>
      </Col>
    </Row>
  </div>
);

export default Footer;
